import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatRoom } from '../../models/models';

const initialState: ChatRoom = {
    id: '',
    name: '',
    userId: '',
    createdAt: null,
};

const chatRoomSlice = createSlice({
    name: 'chatRoom',
    initialState,
    reducers: {
        setChatRoom(state, action: PayloadAction<ChatRoom>) {
            return { ...state, ...action.payload };
        }
    }
});

export const { setChatRoom } = chatRoomSlice.actions;

export default chatRoomSlice.reducer;
